import { SidebarRoute } from "@components/layout/SidebarRouter";
import DOMService from "@services/DOMService";
import React from "react";
import User from "src/models/User";
import ModelGrid from './ModelGrid';

export default class GodinLibGrid extends ModelGrid<User> {

  public formRoute = SidebarRoute.UserForm
  static readonly gridName = "user"

  openSideBar(model: User){
    DOMService.openSidebar(SidebarRoute.SetUserGodinLib, {sectorId: model.sectorId, worker: model})
  }


  onRowClick = (model: User) => {
    this.openSideBar(model);
  }
  
  private formatAssignments(user: User) {
    if (user.sectorAreas && user.sectorAreas.length > 0) {
      return user.sectorAreas
        .map((sa) => `${sa.sector?.name || ("Secteur #" + sa.sectorId)} - ${sa.quartier}`)
        .join(", ");
    }
    if (user.sector?.name && user.quartier) {
      return `${user.sector.name} - ${user.quartier}`;
    }
    return user.quartier || "-";
  }

  gridConfig = {
    headers: ["Nom", "Affectations", "Date"],
    body: [
      (user: User) => <b>{user.getFullName()}</b>,
      (user: User) => <div>{this.formatAssignments(user)}</div>,
      (user: User) => <div>{(new Date(user.startRdv)).toLocaleDateString()} - {(new Date(user.endRdv)).toLocaleDateString()}</div>,
    ]
  }

  showCurrentYard = (e, user) => {
    e.stopPropagation();
    DOMService.openSidebar(SidebarRoute.YardShow, {id: user.currentYard.id})
  }

  multipleActions = [
      ];
  
  onEdit = null;
  onDelete = null;
  onClickNew = () => DOMService.openSidebar(SidebarRoute.SetUserGodinLib, {sectorId: null, worker: null});
}